import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiCustomersList, apiCustomersView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/customers/getData', async datas => {
    const { data } = await apiCustomersList(datas)
    return data
})

export const getView = createAsyncThunk('admin/customers/getView', async id => {
    if (!id) return viewData
    const { data } = await apiCustomersView(id)
    data.image = ''
    return data
})

const viewData = {
    store_id: '',
    first_name: '',
    last_name: '',
    email: '',
    mobile_no: '',
    image: '',
    max_limit: '',
    address: '',
    country_id: '',
    state_id: '',
    city_id: '',
    pincode: '',
}

export const customersSlice = createSlice({
    name: 'admin/customers',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            store_id: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setStoreId: (state, { payload }) => {
            state.table.page = 1
            state.table.store_id = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setStoreId } = customersSlice.actions

export default customersSlice.reducer
